import React, { useState } from 'react';
import { KeyboardDatePicker as MuiKeyboardDatePicker } from 'mui-rff';
import { ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import enLocale from 'date-fns/locale/en-GB';
import { showErrorOnChange } from 'utils/validation';
import datePickertheme from './datePickertheme';

import calendar from 'assets/img/calendar.png';

declare module 'mui-rff/dist/KeyboardDatePicker' {
  interface KeyboardDatePickerProps {
    onChange?: (date: string) => void;
  }
}
interface Props {
  name: string;
  label: string;
  disabled?: boolean;
  disableFuture?: boolean;
  disablePast?: boolean;
  handleChangeDate: (value: string) => void;
}

const KeyboardDatePickerWithState = ({
  name,
  label,
  disabled,
  disableFuture = true,
  disablePast = false,
  handleChangeDate,
}: Props) => {
  const [selectedDate, setSelectedDate] = useState<string | null>(null);

  const handleDateChange = (date: string) => {
    setSelectedDate(date);
    handleChangeDate(String(new Date(date).toLocaleDateString('en-US')));
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enLocale}>
      <ThemeProvider theme={datePickertheme}>
        <MuiKeyboardDatePicker
          value={selectedDate}
          onChange={handleDateChange}
          name={name}
          label={label}
          format="dd-MM-yyyy"
          inputVariant="filled"
          views={['year', 'month', 'date']}
          openTo="year"
          size="small"
          variant="inline"
          InputProps={{
            disableUnderline: true,
          }}
          keyboardIcon={<img src={calendar} alt="Calendar logo" />}
          autoOk
          disableToolbar
          disableFuture={disableFuture}
          disablePast={disablePast}
          fullWidth
          showError={showErrorOnChange}
          disabled={disabled}
        />
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
};

export default KeyboardDatePickerWithState;
